export function getMenuItems(userRole, t) {
  const tr = t || ((key) => key);

  const baseMenuItems = [
    { path: '/course-contents', label: tr('menu.courseContents') },
    { path: '/pretest', label: tr('menu.studentEvaluation') },
    { path: '/optical-reader', label: tr('menu.opticalReader') },
    { path: '/exam-results', label: tr('menu.examResults') },
    // { path: '/pre-midterm-analysis', label: 'Öğrenci ÖÇ/PÖÇ Analizi' },
    // { path: '/kisisel-planlama', label: 'Kişisel Planlama' },
    // { path: '/toplu-analiz', label: 'Kişiselleştirilmiş Analiz' },
    { path: '/personal-analysis', label: 'Arasınav Dönemi Analizi' },
    { path: '/requests', label: tr('menu.requests') },
  ];

  const dekanMenuItems = [
    { path: '/dekan-exam-results', label: tr('menu.dekanExamResults') },
    ...baseMenuItems,
  ];

  const programBaskaniMenuItems = [
    { path: '/program-baskani-exam-results', label: tr('menu.programExamResults') },
    ...baseMenuItems,
  ];

  const rektorMenuItems = [
    { path: '/rektor-exam-results', label: tr('menu.universityExamResults') },
    ...baseMenuItems,
  ];

  if (userRole === 'Dekan') return dekanMenuItems;
  if (userRole === 'Program Başkanı') return programBaskaniMenuItems;
  if (userRole === 'Rektör' || userRole === 'Rektör Yardımcısı') return rektorMenuItems;
  return baseMenuItems;
}
